import { Toast } from 'mint-ui';

let isiOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
let isAndroid = !!(navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Adr') > -1);

window.__BRIDGE_CALLBACK__ = {};
let callbackNum = 0;

export const callHandler = function (name, data, callback, keepalive, errorCallback) {	
	let callbackName = '';
	if (callback && typeof callback === 'function') {
		callbackName = `${name}_${callbackNum++}`;
		window.__BRIDGE_CALLBACK__[callbackName] = function (res) {
			// console.log('__BRIDGE_CALLBACK__', callbackName, res);
			callback(res);
			!keepalive && delete window.__BRIDGE_CALLBACK__[callbackName];
		};
	}
	// console.log('callHandler', name, data, callbackName);

	if (!window.android && !window.webkit) {
		// if (callbackName) {
		//   setTimeout(() => {
		//     window.__BRIDGE_CALLBACK__[callbackName]("eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzUxMiJ9.eyJ1c2VyX2lkIjoiMzA1OTA3MzgiLCJ1c2VyX25hbWUiOiIxNTgxMTExMDAxMiIsImlzcyI6IjMwNTkwNzM4IiwiZXhwIjoxNTc3Njk2NDgxLCJuYmYiOjE1Nzc0MzcyODF9.NQCo2iWorXWCnKbV4UEwJKT4_B5oIquIMgOJ7BvtCcQC6ijj-MclzcQlkHd0Ecy-fdymuwm93nnM2xVemBzVow");
		//   }, 1000);
		// }
		Toast('系统繁忙');
		errorCallback && errorCallback();
		return;
	}

	if (isAndroid) {
		try {
			if (typeof data === 'object') {
				data = JSON.stringify(data);
				console.log('data-isAndroid', data);
			}
			window.android[name](data || '', callbackName);
			console.log(window.android[name], 'window-41');
			
		} catch (e) {
			errorCallback && errorCallback();
		}
	} else {
		try {
			window.webkit.messageHandlers.webViewApp.postMessage({
				[name]: {
					callbackName: callbackName,
					data: data || {}
				}
			});
		} catch (e) {
			errorCallback && errorCallback();
		}
	}
};



// WEBPACK FOOTER //
// ./src/util/jsBridge.js